import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/http";
import { useAuth } from "@/context/AuthContext";
import { AlertTriangle, X } from "lucide-react";

const LOW_THRESHOLD = 20;

export const LowCreditBanner = () => {
  const { user } = useAuth();
  const [biz, setBiz] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const isAdmin = user && (user.role === "owner" || user.role === "admin");

  useEffect(() => {
    if (isAdmin) api.get("/business").then(({ data }) => setBiz(data)).catch(() => {});
  }, [isAdmin]);

  if (!isAdmin || !biz || dismissed || !biz.sms_enabled) return null;

  const price = parseFloat(biz.sms_price_per_msg) || 0.15;
  const bal = parseFloat(biz.sms_credit_balance) || 0;
  const left = price > 0 ? Math.floor(bal / price) : 0;
  if (left >= LOW_THRESHOLD) return null;

  const out = left <= 0;
  return (
    <div className="flex flex-wrap items-center justify-center gap-2 px-4 py-2 text-sm bg-amber-100 text-amber-900" data-testid="low-credit-banner">
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span className="font-medium">
        {out
          ? "You're out of SMS credit — appointment reminders & receipts aren't sending."
          : `Low SMS credit — only ${left} text${left === 1 ? "" : "s"} left. Reminders may stop soon.`}
      </span>
      <Link to="/business-info" className="underline font-semibold hover:opacity-80" data-testid="low-credit-banner-cta">
        Top up now
      </Link>
      <button onClick={() => setDismissed(true)} className="ml-1 rounded-full hover:bg-amber-200/60 p-0.5" title="Dismiss" data-testid="low-credit-banner-dismiss">
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};
